export const ChallengeSection = () => {
    return (
        <section className={`flex-col text-center py-24 bg-cover text-white bg-center`}
                 style={{
                     backgroundImage: `url('/images/home/challenge.png')`,
                     filter: 'grayscale(100%)'
                 }}
        >
            <h1 className={`text-3xl`}>
                AITe 번역 시험, 망설이지 말고 지금 도전하세요
            </h1>
            <br/><br/>
            <p className={`text-xl`}>AITe 번역 시험은 누구에게나 열려 있습니다. <br/>
                AI 번역 실력을 검증하고, 차별화 된 자격을 갖출 수 있는 기회! <br/>
                망설이지 말고 지금 바로 도전하세요.</p>
        </section>
    )
}